import axios from 'axios';

const axiosConfig = axios.create({
    baseURL: 'https://bfg-data-bk.triggo.co/',
});

export default axiosConfig;